/**
 * Site-wide SEO configuration.
 * Update SITE_URL once a real production domain is live.
 */
export const SITE_NAME = "Anytime Vending Machines";
export const SITE_URL = "https://anytimevendingmachines.com";
export const SITE_TAGLINE = "Free vending machines for qualifying workplaces";
export const SITE_DESCRIPTION =
  "Modern vending machines installed, stocked, monitored & serviced at qualifying workplaces — zero upfront cost for 30+ staff or steady foot traffic. Country-wide across Australia, UK, USA & Canada.";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/media/og-share-card.png`;
export const TWITTER_HANDLE = "";
export const CONTACT_PHONE = "+61430472144";
export const CONTACT_PHONE_DISPLAY = "+61 430 472 144";
export const CONTACT_EMAIL = "info.nector@gmail.com";

// Per-route page metadata.
export const PAGE_META = {
  "/": {
    title: "Free Vending Machines For Workplaces · Anytime Vending Machines",
    description:
      "Get a brand new vending machine installed at your workplace for $0 upfront. Fully stocked, serviced & monitored — for sites with 30+ staff or steady foot traffic.",
    keywords:
      "free vending machine, vending machine installation, workplace vending, no upfront cost vending, tap and go vending",
  },
  "/services": {
    title: "Vending Services · Supply, Install, Stock & Service",
    description:
      "End-to-end vending services — $0 machine supply, fast installation, custom stocking, ongoing servicing, modern payments and back-to-base monitoring.",
    keywords:
      "vending services, vending machine supplier, vending stocking, vending servicing, tap and go vending payments",
  },
  "/blog": {
    title: "Vending Tips, Eligibility Guides & Product Ideas · Blog",
    description:
      "Helpful guides for businesses considering a vending machine — eligibility checks, stocking strategies, healthy options and more.",
    keywords:
      "vending machine blog, vending eligibility, how to stock a vending machine, workplace vending tips",
  },
  "/contact": {
    title: "Contact Us · Book a Free Site Visit",
    description:
      "Send your workplace details and we'll confirm eligibility and arrange a free site visit. Country-wide service. info.nector@gmail.com",
    keywords: "contact vending machine, free site visit, book vending machine",
  },
  "/start-your-own-vending-business": {
    title: "Start Your Own Vending Machine Business · $35,000 System + Coaching · Anytime Vending Machines",
    description:
      "Launch your own vending machine business through Anytime Vending Machines. $35,000 one-time investment includes a full inbound + outbound system, professional website, marketing toolkit, and hands-on coaching until you've secured your first 5 sites — then handed over with a supplier introduction.",
    keywords:
      "start vending machine business, vending business setup, vending business coaching, buy a vending business, vending business system, vending business Australia",
  },
  "/about": {
    title: "About Us · Modern Vending That Workplaces Actually Use",
    description:
      "We modernise workplace vending — brand new machines, custom stock, ongoing servicing and back-to-base monitoring. Free installs for qualifying sites.",
    keywords: "about anytime vending, modern vending machines, workplace vending company",
  },
  "/privacy": {
    title: "Privacy Policy · How We Handle Your Data",
    description:
      "How we collect, use, store and protect personal information when you visit our website, submit forms or engage with our services.",
    keywords: "privacy policy, data handling, vending privacy",
  },
  "/terms": {
    title: "Terms & Conditions · Vending Machine Service Terms",
    description:
      "Terms & Conditions covering use of our website and our free vending machine installation services across Australia, UK, USA & Canada.",
    keywords: "terms and conditions, vending terms, service agreement",
  },
  "/buy-a-vending-machine": {
    title: "Buy a Vending Machine — or Get One Installed Free · Australia",
    description:
      "Buy a modern vending machine or qualify for a free install. 30+ staff workplaces in Australia can get a fully stocked, serviced machine at $0 upfront.",
    keywords: "buy vending machine Australia, free vending machine Australia, vending machine installation Australia",
  },
  "/buy-a-vending-machine-uk": {
    title: "Buy a Vending Machine — or Get One Installed Free · UK",
    description:
      "Buy a modern vending machine or qualify for a free install in the UK. Workplaces with 30+ staff or steady foot traffic can receive a machine at zero upfront cost.",
    keywords: "buy vending machine UK, free vending machine UK, workplace vending UK",
  },
  "/buy-a-vending-machine-usa": {
    title: "Buy a Vending Machine — or Get One Installed Free · USA",
    description:
      "Buy a vending machine or qualify for a free install across the USA. Workplaces with 30+ staff can receive a fully stocked machine at zero upfront cost.",
    keywords: "buy vending machine USA, free vending machine USA, office vending machine America",
  },
  "/free-vending-machines-for-businesses": {
    title: "Free Vending Machines For Businesses · Australia",
    description:
      "Free vending machines for businesses with 30+ staff or steady foot traffic. Stocked, serviced and monitored by us — zero upfront cost across Australia.",
    keywords: "free vending machines business, free workplace vending machine, $0 vending machine Australia",
  },
  "/free-vending-machines-for-businesses-uk": {
    title: "Free Vending Machines For Businesses · UK",
    description:
      "Free vending machines for UK businesses with 30+ staff or steady foot traffic. Tap & Go payments, stocked & serviced — no upfront cost.",
    keywords: "free vending machine UK business, workplace vending UK, free office vending UK",
  },
  "/free-vending-machines-for-businesses-usa": {
    title: "Free Vending Machines For Businesses · USA",
    description:
      "Free vending machines for US businesses with 30+ staff or steady foot traffic. Fully stocked, serviced and tap-to-pay enabled — no upfront cost.",
    keywords: "free vending machine USA business, office vending machine, workplace vending America",
  },
  "/thank-you": {
    title: "Thank You · We'll Be In Touch Shortly",
    description: "Your request has been received. A member of our team will confirm eligibility and reach out within one business day.",
    keywords: "thank you, vending machine inquiry confirmation",
    noindex: true,
  },
};
